<template>
  <div class="ht-elent-var-pc flex-col dashboard-container" v-if="deviceStore.type == 'desktop'">
    <div class="flex-row title-div-ht justify-content-space-between">
      <div class="flex-row align-items-center">
        <h>{{ htTiltes }}</h>
      </div>
      <div></div>
      <div class="flex-row align-items-center">
        <div class="touxiang_div"></div>
        <div>欢迎 {{ from.yhm }} 登陆！</div>
        <div>
          <el-button type="primary" @click="logout">退出登录</el-button>
        </div>
      </div>
    </div>
    <div class="flex-row count-div-ht">
      <div class="menu-div">
        <MenuBar :menuData="MenuBarData" @itemClick="menuDomClick" :accordion="true"></MenuBar>
      </div>
      <div class="count-div">
        <component :is="currentComponent_pc" />
      </div>
    </div>
  </div>
  <div v-else-if="deviceStore.type == 'mobile'" class="mobile_div">
    <div class="top_div">
      <component :is="currentComponent" :datainfo="dataInfo" @jump="jumpPage" :searchNow="searchNow" />
    </div>
    <div class="bottom_div">
      <div @click="clickHome">
        <div v-html="homesvg"></div>
        <div>首页</div>
      </div>
      <div @click="clickProcess">
        <div v-html="processsvg"></div>
        <div>流程</div>
      </div>
      <div @click="clickPersonal">
        <div v-html="personalsvg"></div>
        <div>个人中心</div>
      </div>
    </div>
  </div>
</template>

<script>
import { useDeviceStore } from '@/stores/device.js';
import { svgRead } from '@/svgIcon/main';
import request from '@/utils/request';
import { creatMenuData_pc, htTilte } from '@/interface/stzbxl/mainSTconfig.js';

export default {
  name: 'DashboardPage',
  data() {
    return {
      from: {
        'yhm': '',
        'Avatar': ''
      },
      personalsvg: '',
      homesvg: '',
      processsvg: '',
      clickedColor: "rgb(18 136 255)",/**选中后的颜色 */
      noClickedColor: "rgb(136, 137, 138)",/**未选中的颜色 */
      clickState: '',
      currentComponent: '',
      dataInfo: { "types": "", "isOnUserClick": true },
      searchNow: false,
      MenuBarData: []/**菜单栏数据 */,
      currentComponent_pc: '',
      htTiltes: htTilte
    }
  },
  setup() {
    const deviceStore = useDeviceStore();
    console.log("打印用户设备类型");
    console.log(deviceStore.type);
    return { deviceStore };
  },
  methods: {
    logout() {
      this.$messageX.tipWin({ "magess": "确定退出？", "magess_title": "提示" }, this.exit, this.emptyFunction);
    },
    exit() {
      localStorage.removeItem('token');
      this.$router.push({ name: 'LoginPage' });
    },
    emptyFunction() {

    },
    clearClickState(value) {
      this.homesvg = svgRead("home-a", this.noClickedColor, 30, 30);
      this.personalsvg = svgRead('personal-a', this.noClickedColor, 30, 30);
      this.processsvg = svgRead("process-a", this.noClickedColor, 30, 30);
      if (value == 'home') {
        this.homesvg = svgRead("home-a", this.clickedColor, 30, 30);
        this.currentComponent = "HomePage";
      }
      if (value == 'personal') {
        this.personalsvg = svgRead('personal-a', this.clickedColor, 30, 30);
        this.currentComponent = "PersonalPage";
      }
      if (value == 'process') {
        this.processsvg = svgRead("process-a", this.clickedColor, 30, 30);
        this.currentComponent = "ProcessPage";
      }

    },
    clickHome() {
      if (this.clickState != 'home') {
        this.clickState = 'home';
        this.clearClickState(this.clickState);

      }

    },
    clickProcess() {
      if (this.clickState != 'process') {
        this.clickState = 'process';
        this.clearClickState(this.clickState);

      }
    },
    clickPersonal() {
      if (this.clickState != 'personal') {
        this.clickState = 'personal';
        this.clearClickState(this.clickState);

      }
    },
    jumpPage(data) {
      if (data.page == "Process") {
        this.clickProcess();
        this.dataInfo = { "types": data.types, "isOnUserClick": false };
        this.searchNow = true;
      }
    },
    menuDomClick(data) {
      console.table(data);
      console.log('点击菜单');
    },
    async obtainMenuBarData() {
      console.log('获取菜单数据');
      try {
        const res = await request.post('/ObtainMenuData', {
          address: location.href,
          Short: 'pc'
        });
        this.$messageX.xiaoxiti("c", res.message);
        this.MenuBarData = res.response.data;
      } catch (err) {
        if (err.status == 444) {
          this.MenuBarData = creatMenuData_pc;
        } else {
          console.log('失败:', err)
          if (err.response.data.message) {
            this.$messageX.xiaoxiti("e", err.response.data.message);
          } else {
            this.initData();
            this.$messageX.xiaoxiti("e", err.message);
          }
        }

      }
    },
    obtainUserInfo() {
      let userData = JSON.parse(localStorage.background_user_info);
      this.from.yhm = userData.Accounts;
      this.from.Avatar = userData.Avatar;
    }
  },
  mounted() {
    this.obtainMenuBarData();
    this.obtainUserInfo();
    this.clickState = 'home';
    this.clearClickState(this.clickState);
    localStorage.setItem('current_address', 'DashboardPage');

    this.$socket.on('background_login', (data) => {
      if (this.$socket.diversion(data).success) {
        if (data.notify) {
          if (data.notifyType == 'message') {
            this.$messageX.xiaoxiti("i", data.message);
          } else if (data.notifyType == 'confirm') {
            confirm(data.message);
          } else {
            console.error('回传数据包错误！');
          }
        }
        localStorage.clear();
        this.$router.push({ name: 'LoginPage' });
      }
    });
  }
};
</script>

<style scoped>
.ht-elent-var-pc {
  /* 定义pc端的自定义属性 */
  --el-title-div-height: 75px;
  /* 设置标题顶部区域的高度 */
  --el-count-div-width: 100px;
  /* 设置菜单区域的宽度 */
}

.cs {
  color: rgb(136, 137, 138);
}

.dashboard-container {
  height: 100vh;
  width: 100vw;
}

.mobile_div {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-evenly;
  align-items: center;
}

.bottom_div {
  width: 100%;
  height: 80px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-around;
  align-items: center;
  box-shadow: 9px 8px 30px 5px rgba(0, 0, 0, 0.15);
}

.top_div {
  width: 100%;
  height: calc(100% - 80px);
  background-color: rgb(250 250 250);
}

.touxiang_div {
  border-radius: 100%;
  background-color: rgb(0, 149, 248);
  height: 50px;
  width: 50px;
  margin-right: 10px;
  border: 2px solid #0150d8;
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.title-div-ht {
  height: var(--el-title-div-height);
  width: 100%;
  padding: 0px 20px 0px 20px;
}

.count-div-ht {
  height: calc(100% - var(--el-title-div-height));
  width: 100%;
}

.menu-div {
  height: 100%;
  width: var(--el-count-div-width);
}

.count-div {
  height: 100%;
  width: calc(100% - var(--el-count-div-width));
}
</style>
